namespace TabAurous.JobWork {
    export namespace JobWorkReturnTaxService {
        export const baseUrl = 'JobWork/JobWorkReturnTax';

        export declare function Create(request: Serenity.SaveRequest<JobWorkReturnTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JobWorkReturnTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkReturnTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkReturnTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "JobWork/JobWorkReturnTax/Create",
            Update = "JobWork/JobWorkReturnTax/Update",
            Delete = "JobWork/JobWorkReturnTax/Delete",
            Retrieve = "JobWork/JobWorkReturnTax/Retrieve",
            List = "JobWork/JobWorkReturnTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JobWorkReturnTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
